import { fetch, post } from "./base";

export const generateVoiceForElevenLabs = async (data, cache = false) => {
  return post("/elevenlabs/generate_voice/", data);
};
export const generateVoiceForText = async (data, cache = false) => {
  return post("/voiceScript.py/", data);
};

export const generateTranslationForText = async (data, cache = false) => {
  return post("/translateScript.py/", data);
};

export const getAllUserAudioScript = async (userId, cache = true) => {
  return fetch(`/useraudio/?user_id=${userId}`, { cache: false });
};

export const getAllElevenLabVoices = async (cache = true) => {
  return fetch(`/elevenlabs/get_voices/`, { cache });
};

export const getAllSubtitle = async (cache = true) => {
  return fetch("/subtitle/get-templates/", { cache });
};

export const getAllElevenLabVoicesAccentedVoiceAPI = async (cache = true) => {
  return fetch("/elevenlabs/accented_voice/parameters/", { cache });
};

export const generateAccentVoice = async (data, cache = false) => {
  return post("/elevenlabs/accented_voice/generate/", data);
};

export const generateAIVoice = async (data, cache = false) => {
  return post("/ai_voices/", data);
};
